import { render } from "./EduAreaView.vue?vue&type=template&id=0e6e568d&scoped=true"
import script from "./EduAreaView.vue?vue&type=script&lang=js"
export * from "./EduAreaView.vue?vue&type=script&lang=js"

import "./EduAreaView.vue?vue&type=style&index=0&id=0e6e568d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6e568d"]])

export default __exports__